import { message } from 'antd';
import { ReactNode } from 'react';

export function showErrorMessage(text: ReactNode, options?: { duration?: number; key?: number }): void {
  message.error({
    content: text,
    className: 'errorMessage',
    duration: options?.duration,
    key: options?.key,
  });
}

export function showWarningMessage(text: string): void {
  message.warn({
    content: text,
    className: 'warningMessage',
  });
}

export function showSuccessMessage(text: string): void {
  message.warn({
    content: text,
    className: 'successMessage',
  });
}
